import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function TwitterIcon({ link, style, className }) {
  if (logComponent('TwitterIcon')) { console.debug('TwitterIcon rendered'); }

  return  (
    <a href={link} className={className} title="Twitter" target="_blank" rel="noopener noreferrer">
      <FontAwesomeIcon style={style} icon={['fab', 'twitter-square']} />
    </a>
  )
}